<template>
  <a
    :href="url"
    target="_blank"
    class="body-large link-custom padding-top-xs padding-bottom-xs padding-left-xs"
    :class="{ 'padding-right-xs': !isProductPerksEnabledPhase2 }"
    @click="handleClick"
  >
    <span class="text-wrapper">
      <span class="personalized-offers-dark-medium offer-icon"></span>
      <span class="text">{{ label }}</span>
    </span>
    <span class="chevron-large-right-dark-small"></span>
  </a>
</template>

<script setup>
import useOncePerSession from '~/composables/utils/useOncePerSession';
import { tagShopMoreLinkClick } from '~/features/analytics/shopMore';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';

defineProps({
  url: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});
const { isProductPerksEnabledPhase2 } = useFeatureEligibility();

const { hasBeenUsed } = useOncePerSession('shop-more-extended:link-clicked');

function handleClick() {
  if (!hasBeenUsed.value) {
    tagShopMoreLinkClick();
    hasBeenUsed.value = true;
  }
}
</script>

<style lang="scss" brand="mcom">
@import '~settingSCSS';
@import '~@csgIcons/new/personalized-offers-dark-medium';
@import '~@csgIcons/new/chevron-large-right-dark-small';

.body-large {
  @include body(large);
}

.link-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: $background-color;
  text-decoration: none;
  border-radius: rem-calc(5);

  .text-wrapper {
    display: flex;
    align-items: center;
    width: calc(100% - rem-calc(24));
  }

  .text {
    display: block;
    width: calc(100% - rem-calc(36));
  }

  .offer-icon {
    margin-right: rem-calc(12);
  }
}
</style>
